var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 31,
    fill: "white",
    stroke: "#03CDEF",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6673 26.6668H39.6673V21.3335H21.0007C19.534 21.3335 18.334 22.5335 18.334 24.0002V38.6668H21.0007C21.0007 40.8802 22.7873 42.6668 25.0007 42.6668C27.214 42.6668 29.0007 40.8802 29.0007 38.6668H37.0007C37.0007 40.8802 38.7873 42.6668 41.0007 42.6668C43.214 42.6668 45.0006 40.8802 45.0006 38.6668H47.6673V32.0002L43.6673 26.6668ZM25.0007 40.6668C23.894 40.6668 23.0007 39.7735 23.0007 38.6668C23.0007 37.5602 23.894 36.6668 25.0007 36.6668C26.1073 36.6668 27.0007 37.5602 27.0007 38.6668C27.0007 39.7735 26.1073 40.6668 25.0007 40.6668ZM43.0007 28.6668L45.614 32.0002H39.6673V28.6668H43.0007ZM41.0007 40.6668C39.894 40.6668 39.0007 39.7735 39.0007 38.6668C39.0007 37.5602 39.894 36.6668 41.0007 36.6668C42.1073 36.6668 43.0007 37.5602 43.0007 38.6668C43.0007 39.7735 42.1073 40.6668 41.0007 40.6668Z",
    fill: "#03CDEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckIcon);
export default __webpack_public_path__ + "static/media/TruckIcon.ad6b86bf22c8d403793e32818109d4af.svg";
export { ForwardRef as ReactComponent };